module.exports = __webpack_public_path__ + "img/view-list.93862874.svg";